import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {
  listConfigSelector,
  rxShowMileageLogEditor,
  rxToggleInactiveCars,
  selectAllMileageLogs
} from "../../../slices/mileageLogsSlice";
import {MODE_CREATE} from "../../../codes";
import {rxShowCarEditor, selectAllCars} from "../../../slices/carsSlice";

const useMileageLogs = () => {
  const dispatch = useDispatch();

  const {t} = useTranslation("cars");

  const {selectedCarId, inactiveCars} = useSelector(listConfigSelector);

  const allCars = useSelector(selectAllCars);

  const selectedCar = allCars.find(c => c.id === selectedCarId);
  const mileageLogs = useSelector(selectAllMileageLogs).filter(ml => ml.car === selectedCarId);

  const showMileageLogEditor = (mode, mileageLog) => dispatch(rxShowMileageLogEditor({mode, mileageLog}));

  const showCarEditor = () => dispatch(rxShowCarEditor({mode: MODE_CREATE, car: {}}));

  const toggleInactiveCars = () => {
    dispatch(rxToggleInactiveCars());
  }

  return {
    t,
    allCars,
    selectedCar,
    mileageLogs,
    showMileageLogEditor,
    showCarEditor,
    inactiveCars,
    toggleInactiveCars
  };
};

export default useMileageLogs;
